import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, GuardResult, MaybeAsync, Router } from '@angular/router';
import { AuthService } from '../../core/services/auth.service';
import { Authorities } from '../enums/authorities.enum';

export const canActivateAnyAuthGuard = (route: ActivatedRouteSnapshot): MaybeAsync<GuardResult> => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const auths: Authorities[] = route.data?.['authorities'] ?? [];
  const noAuthsRequired = auths.length === 0;
  if (noAuthsRequired || authService.hasAnyAuthority(auths)) {
    return true;
  }

  router.navigate(['/not-found']);
  return false;
}
